import { render } from "./touchspinWithPrefix.vue?vue&type=template&id=3b18d757"
import script from "./touchspinWithPrefix.vue?vue&type=script&lang=js"
export * from "./touchspinWithPrefix.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__